type RequestIdleCallbackHandle = unknown;
type RequestIdleCallbackOptions = {
  timeout: number;
};
type RequestIdleCallbackDeadline = {
  readonly didTimeout: boolean;
  timeRemaining: () => number;
};

declare global {
  interface Window {
    requestIdleCallback?: (
      callback: (deadline: RequestIdleCallbackDeadline) => void,
      opts?: RequestIdleCallbackOptions
    ) => RequestIdleCallbackHandle;
    cancelIdleCallback?: (id: RequestIdleCallbackHandle) => void;
  }
}

/**
 * Wait until after the onload event to run a callback.
 */
const deferUntilLoad = (callback: () => void) => {
  if (typeof window === "undefined") return;

  // requestIdleCallback isn't supported by Safari or IE so just call
  // immediately.
  const requestIdleCallback =
    typeof window.requestIdleCallback !== "undefined"
      ? window.requestIdleCallback
      : () => callback();

  // If the document is already complete, call
  if (document.readyState === "complete") {
    requestIdleCallback(callback);
  } else {
    // Otherwise, set a load event handler.
    window.addEventListener("load", () => {
      requestIdleCallback(callback);
    });
  }
};

export default deferUntilLoad;
